module.exports = __webpack_public_path__ + "static/history1-f52ab14b085fdc2ffb053ab221728a10.jpg";